import {
  ADD_EXPRESS_ORDER_ITEMS_TO_CART,
  ADD_EXPRESS_ORDER_ITEMS_TO_CART_FULFILLED,
  ADD_EXPRESS_ORDER_ITEMS_TO_CART_REJECTED,
  ADD_EXPRESS_ORDER_ITEMS_TO_WISHLIST,
  ADD_EXPRESS_ORDER_ITEMS_TO_WISHLIST_FULFILLED,
  ADD_EXPRESS_ORDER_ITEMS_TO_WISHLIST_REJECTED,
  CLEAR_ADD_EXPRESS_ORDER_ITEMS_TO_CART,
  CLEAR_ADD_EXPRESS_ORDER_ITEMS_TO_WISHLIST,
  CLEAR_EXPRESS_ORDER,
  REMOVE_VERIFY_ITEM,
  UPLOAD_CSV,
  UPLOAD_CSV_FULFILLED,
  UPLOAD_CSV_REJECTED,
  VERIFY,
  VERIFY_FULFILLED,
  VERIFY_REJECTED,
} from 'b2b-apps/shop/expressOrder/redux/actionTypes';
import {
  AddItemsToCartAction,
  AddItemsToCartFulfilledAction,
  AddItemsToCartRejectedAction,
  AddItemsToWishlistAction,
  AddItemsToWishlistFulfilledAction,
  AddItemsToWishlistRejectedAction,
  AddItemsToWishlistType,
  ClearAddItemsToCartAction,
  ClearAddItemsToWishlistAction,
  ClearExpressOrderAction,
  RemoveVerifyItemAction,
  UploadCsvAction,
  UploadCsvFulfilledAction,
  UploadCsvRejectedAction,
  VerifyAction,
  VerifyFulfilledAction,
  VerifyRejectedAction,
} from 'b2b-apps/shop/expressOrder/redux/types';
import { AddItemsToCartType } from 'b2b-common/core/cart/api/CartTypes';
import {
  AddItemsToCartRequestBodyType,
  AddItemsToWishlistRequestBodyType,
  VerifyRequestBodyType,
  VerifyType,
} from 'b2b-common/core/expressOrder/api/ExpressOrder.types';

const addItemsToCart = (data: AddItemsToCartRequestBodyType): AddItemsToCartAction => ({
  type: ADD_EXPRESS_ORDER_ITEMS_TO_CART,
  payload: {
    data,
  },
});

const addItemsToCartFulfilled = (response: AddItemsToCartType): AddItemsToCartFulfilledAction => ({
  type: ADD_EXPRESS_ORDER_ITEMS_TO_CART_FULFILLED,
  payload: {
    data: response,
  },
});

const addItemsToCartRejected = (error: ErrorType): AddItemsToCartRejectedAction => ({
  type: ADD_EXPRESS_ORDER_ITEMS_TO_CART_REJECTED,
  payload: {
    error,
  },
});

const addItemsToWishlist = (data: AddItemsToWishlistRequestBodyType): AddItemsToWishlistAction => ({
  type: ADD_EXPRESS_ORDER_ITEMS_TO_WISHLIST,
  payload: {
    data,
  },
});

const addItemsToWishlistFulfilled = (response: AddItemsToWishlistType): AddItemsToWishlistFulfilledAction => ({
  type: ADD_EXPRESS_ORDER_ITEMS_TO_WISHLIST_FULFILLED,
  payload: {
    data: response,
  },
});

const addItemsToWishlistRejected = (error: ErrorType): AddItemsToWishlistRejectedAction => ({
  type: ADD_EXPRESS_ORDER_ITEMS_TO_WISHLIST_REJECTED,
  payload: {
    error,
  },
});

const clearExpressOrder = (): ClearExpressOrderAction => ({
  type: CLEAR_EXPRESS_ORDER,
});

const clearAddItemsToCart = (): ClearAddItemsToCartAction => ({
  type: CLEAR_ADD_EXPRESS_ORDER_ITEMS_TO_CART,
});

const clearAddItemsToWishlist = (): ClearAddItemsToWishlistAction => ({
  type: CLEAR_ADD_EXPRESS_ORDER_ITEMS_TO_WISHLIST,
});

const removeVerifyItem = (index: number): RemoveVerifyItemAction => ({
  type: REMOVE_VERIFY_ITEM,
  payload: {
    index,
  },
});

const uploadCsv = (file: any): UploadCsvAction => ({
  type: UPLOAD_CSV,
  payload: {
    file,
  },
});

const uploadCsvFulfilled = (response: VerifyType): UploadCsvFulfilledAction => ({
  type: UPLOAD_CSV_FULFILLED,
  payload: {
    data: response,
  },
});

const uploadCsvRejected = (error: ErrorType): UploadCsvRejectedAction => ({
  type: UPLOAD_CSV_REJECTED,
  payload: {
    error,
  },
});

const verify = (data: VerifyRequestBodyType): VerifyAction => ({
  type: VERIFY,
  payload: {
    data,
  },
});

const verifyFulfilled = (response: VerifyType): VerifyFulfilledAction => ({
  type: VERIFY_FULFILLED,
  payload: {
    data: response,
  },
});

const verifyRejected = (error: ErrorType): VerifyRejectedAction => ({
  type: VERIFY_REJECTED,
  payload: {
    error,
  },
});

export {
  addItemsToCart,
  addItemsToCartFulfilled,
  addItemsToCartRejected,
  addItemsToWishlist,
  addItemsToWishlistFulfilled,
  addItemsToWishlistRejected,
  clearAddItemsToCart,
  clearAddItemsToWishlist,
  clearExpressOrder,
  removeVerifyItem,
  uploadCsv,
  uploadCsvFulfilled,
  uploadCsvRejected,
  verify,
  verifyFulfilled,
  verifyRejected,
};
